import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

let initialState = {
  userData: ["Jack"],
  blessings: [],
  tasks: [],
  completed: [],
  content: {
    email: "",
    password: "",
  },
  affirm: 0,
  quote: {
    content: "I’m not a man of preacher of love. am a war, am a fight, am Inbadoski Bahose. Violence shall spread",
    status: "idle"
  },
  theme: {
    background: "#fff",
    text: 'black'
  }
};

export const fetchPosts = createAsyncThunk(
  "/reducers/fetchPosts",
  async (login) => {
    console.log('yes')
    try {
      const response = await axios({
        method: "POST",
        credentials: 'same-origin',
        url: 'https://hanchor.herokuapp.com/hanchor/login',
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(login),
      }).catch((err)=>{
        console.log(err)
      });
      const newBearer = response.json();
      console.log(newBearer)
      return newBearer;
    } catch (err) {
      return err.messsage;
    }
  }
);
export const fetchQuote = createAsyncThunk('/reducers/fetchQuote', async () =>{
  try {
    const response = await fetch("https://api.quotable.io/random");
    const data = await response.json();
    console.log(data)
    return data;
  } catch (error) {
    console.error(error);
    return ({content: "Oops... Something went wrong."})
  }
});

export const userSlice = createSlice({
  name: "counter",
  initialState,
  reducers: {
    users: (state, action) => {
      state.userData = action.payload;
    },
    blessing: (state, action) => {
      state.blessings.push(action.payload);
    },
    task: (state, action) => {
      state.tasks.push(action.payload);
    },
    deleteTask: (state, action) => {
      console.log(action.payload)
      state.tasks = state.tasks.filter((task)=> task.id !== action.payload)
    },
    clearTasks: (state) => {
      state.completed = [];
    },
    completedTask: (state, action) => {
      state.completed.push(action.payload);
    },
    content: (state, action) => {
      state.content.email = action.payload[0];
      state.content.password = action.payload[1];
    },
    affirms: (state, action) => {
      state.affirm = action.payload;
    },
    themes: (state, action) => {
      state.theme = action.payload;
    },
  },
  extraReducers: {
    [fetchQuote.pending]: (state, action) => {
      state.quote.status = 'loading'
    },
    [fetchQuote.fulfilled]: (state, action) => {
      state.quote.status = 'success';
      state.quote.content = action.payload;
    },
    [fetchQuote.rejected]: (state, action) => {
      state.quote.status = 'failed';
      state.quote.content = action.payload;
    }
  },
});

export const setUser = (state) => state.user.userData;
export const setBlessing = (state) => state.user.blessings;
export const setTask = (state) => state.user.tasks;
export const setCompleted = (state) => state.user.completed;
export const setAffirm = (state) => state.user.affirm;
export const setQuote = (state) => state.user.quote.content;
export const setStatus = (state) => state.user.quote.status;
export const setTheme = (state) => state.user.theme

export const { users, blessing, task, date, content, completedTask, deleteTask, clearTasks, affirms, themes } = userSlice.actions;

export default userSlice.reducer;
